import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Notifier } from '../interfaces/notifier';
import { AuthService } from '../services/auth/auth.service';
import { NotifierService } from '../services/notifier.service';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorService implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private notifierService: NotifierService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    let token = this.authService.getAuthSession()?.token;
    const skipIntercept = req.headers.has('skip');

    if (skipIntercept) {
      const modifiedReq = req.clone({
        headers: req.headers.delete('skip'),
      });
      return next.handle(modifiedReq);
    }

    const finallyRequest = () => {
      const modifiedReq = req.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
      });

      return next.handle(modifiedReq).pipe(
        catchError((error) => {
          return this.handleResponseError(error);
        })
      );
    };

    if (!this.authService.isTokenInvalid()) {
      return finallyRequest();
    } else {
      return this.authService.refreshToken().pipe(
        switchMap(() => {
          token = this.authService.getAuthSession()?.token;
          return finallyRequest();
        }),
        catchError((error) => {
          return this.handleResponseError(error);
        })
      );
    }
  }

  handleResponseError(errorRes: any) {
    if (errorRes.error.message === 'INVALID_TOKEN') {
      this.authService.logoutByInvalidToken();
    }

    if (errorRes.error && Array.isArray(errorRes.error)) {
      const errorArr: Notifier = {
        displayMessage: 'Ops! Algo não saiu como esperado.',
        messageType: 'errorNotifier',
        buttonTxt: 'OK',
        notifierList: errorRes.error,
      };

      this.notifierService.showNotification(errorArr);
    }

    return throwError(errorRes);
  }
}
